export const getImageUrl = (imageUrl?: string) => {
	let url = imageUrl;
	if (!url)
	{
		return undefined;
	}

	// if starts with // set http://
	if (url?.startsWith("//"))
	{
		url = `https:${url}`;
	}

	if (url?.startsWith("http") && !url?.includes("base64") && url?.includes(process.env.NEXT_PUBLIC_TRUSTPILOT_DOMAIN || 'stableproxy.'))
	{
		const apiHost = new URL(process.env.NEXT_PUBLIC_API_URL || process.env.APP_URL || 'https://api.stableproxy.com');
		const nUrl = new URL(url);
		nUrl.hostname = apiHost.hostname;
		nUrl.port = apiHost.port;

		url = nUrl.toString();
	}
	else if (url?.startsWith("/"))
	{
		const apiHost = new URL(process.env.NEXT_PUBLIC_API_URL || process.env.APP_URL || 'https://api.stableproxy.com');
		apiHost.pathname = url;

		url = apiHost.toString();
	}

	return url;
}